import cloneDeep from "lodash/cloneDeep";
import slice from "lodash/slice";
import { CheckboxesFieldValue, Profile, Subtemplate } from "PFCore/types";

import { useVisiblePermittedProperties } from "./use_visible_permitted_properties";

type GetSubtemplateDefaultValues = {
  subtemplate: Subtemplate;
  activityCreator: Profile | null;
};

type SubtemplateCustomField = {
  fieldName: string;
  values: string[];
};

type SubtemplateMetadataField = {
  fieldName: string;
  values: string | CheckboxesFieldValue;
};

export const useSubtemplateDefaultValues = () => {
  const { getVisiblePermittedProperties } = useVisiblePermittedProperties();

  const getSubtemplateDefaultValues = ({ subtemplate, activityCreator }: GetSubtemplateDefaultValues) => {
    const visibleProperties = getVisiblePermittedProperties({ subtemplate, activityCreator });

    const visiblePropertiesWithValues = visibleProperties
      .filter(({ type }) => (type as string) !== "booking_category_id")
      .filter((property) => !!property.values?.length);

    const metadataFields: SubtemplateMetadataField[] = visiblePropertiesWithValues
      .filter((property) => property.type !== "custom_field")
      .map((property) => {
        const defaultValue =
          property.type === "checkboxes"
            ? (cloneDeep(property.values || []) as CheckboxesFieldValue)
            : (property.values![0] as string);

        return {
          fieldName: property.name,
          values: defaultValue
        };
      });

    const customFields: SubtemplateCustomField[] = visiblePropertiesWithValues
      .filter((property) => property.type === "custom_field")
      .map((property) => {
        const isSingle = property.kind === "single";
        const propertyValues = property.values as string[];

        return {
          fieldName: property.name,
          values: isSingle ? slice(propertyValues, 0, 1) : propertyValues
        };
      });

    return {
      metadataFields,
      customFields
    };
  };

  return {
    getSubtemplateDefaultValues
  };
};
